import React from "react";
import { Table, Button, Card, Row, Col, Alert } from "antd";

const columns = [
    { title: "Seri", dataIndex: "seri", key: "seri" },
    { title: "Jenis", dataIndex: "jenis", key: "jenis" },
    { title: "Nomor", dataIndex: "nomor", key: "nomor" },
    { title: "Tanggal", dataIndex: "tanggal", key: "tanggal" },
    { title: "Fasilitas", dataIndex: "fasilitas", key: "fasilitas" },
    { title: "Izin", dataIndex: "izin", key: "izin" },
    { title: "Kantor", dataIndex: "kantor", key: "kantor" },
    { title: "File", dataIndex: "file", key: "file" },
];

const Dokumen = ({ data, setData }) => {
    return (
        <div>
            <Alert
                message="Wajib Melampirkan Dokumen Invoice dan Dokumen B/L atau AWB"
                type="warning"
                showIcon
                style={{ marginBottom: 20 }}
            />
            <Card title="Dokumen Lampiran" extra={<Button type="primary">Tambah</Button>}>
                <Table columns={columns} dataSource={[]} pagination={false} />
            </Card>
        </div>
    );
};

export default Dokumen;
